import { IMAGES } from "@/lib/config";
import { Leaf, BookOpen, MapPin } from "lucide-react";
import useReveal from "@/hooks/useReveal";

export default function About() {
    const ref = useReveal();
    return (
        <section id="apropos" ref={ref} data-testid="about-section" className="relative py-24 md:py-32">
            <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
                <div className="lg:col-span-5 order-2 lg:order-1 reveal">
                    <div className="relative">
                        <div className="aspect-[4/5] overflow-hidden rounded-sm border border-border">
                            <img src={IMAGES.about} alt="Artisan diagnostiqueur du bâti ancien au travail sur un mur en pierre avec un enduit à la chaux" loading="lazy" className="w-full h-full object-cover" />
                        </div>
                        <div className="absolute -right-4 -bottom-6 hidden md:block w-40 h-40 rounded-sm overflow-hidden border-4 border-cream">
                            <img src={IMAGES.texture} alt="Texture d'enduit à la chaux aérienne sur mur ancien" loading="lazy" className="w-full h-full object-cover" />
                        </div>
                    </div>
                </div>

                <div className="lg:col-span-7 order-1 lg:order-2 reveal">
                    <span className="label-overline text-brand">À propos</span>
                    <h2 className="mt-4 font-heading text-3xl md:text-5xl font-light tracking-tighter text-ink leading-tight">
                        Diagnostiqueur <span className="italic">et</span> artisan.
                        <br />
                        Deux casquettes, <span className="italic">une cohérence.</span>
                    </h2>
                    <p className="mt-6 text-base md:text-lg text-stone2 leading-relaxed">
                        J'observe, j'écoute la maison, puis je propose. Mon approche
                        s'oppose au « tout-ciment » qui asphyxie les murs anciens.
                        Quand je ne diagnostique pas, je restaure moi-même —
                        avec des matériaux naturels, sains et compatibles avec le bâti existant.
                    </p>

                    <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-5">
                        <Pillar
                            icon={Leaf}
                            title="Matériaux biosourcés"
                            text="Chaux, terre, chanvre, lin, paille, bois, liège."
                        />
                        <Pillar
                            icon={BookOpen}
                            title="Pédagogie"
                            text="Vous expliquer pour que vous décidiez en connaissance de cause."
                        />
                        <Pillar
                            icon={MapPin}
                            title="Proximité"
                            text="Eure-et-Loir, Île-de-France et régions limitrophes."
                        />
                    </div>
                </div>
            </div>
        </section>
    );
}

function Pillar({ icon: Icon, title, text }) {
    return (
        <div className="border-l-2 border-brand/60 pl-4 py-1">
            <div className="flex items-center gap-2 text-ink">
                <Icon size={18} className="text-brand" />
                <h3 className="font-heading text-base font-medium tracking-tight">{title}</h3>
            </div>
            <p className="mt-2 text-sm text-stone2 leading-relaxed">{text}</p>
        </div>
    );
}
